import styled from '@emotion/styled';

export const ModalWithImageContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  maxWidth: 461,
  gap: 16,
  '& h1': {
    fontSize: 16,
    fontWeight: 600,
    margin: 0,
  },
  '& p': {
    padding: '0 35px',
    fontSize: 13,
    fontWeight: 400,
    margin: 0,
  },
}));

export const BoldStatement = styled.span((_) => ({
  fontWeight: 600,
}));
